import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface PaymentRequest {
  referenceNumber: string;
  amount: number;
  cardDetails: {
    number: string;
    expiryDate: string;
    cvv: string;
  };
  [key: string]: any; // For any additional fields that might be needed
}

@Injectable({
  providedIn: 'root'
})
export class QuickPayService {
  constructor(private http: HttpClient) {}

  /**
   * Get payment details for a given Oriel reference number
   * @param referenceNumber The Oriel reference number to look up
   * @returns Observable with the reference details
   */
  getReferenceDetails(referenceNumber: string): Observable<any> {
    if (!referenceNumber || referenceNumber.trim() === '') {
      return throwError(() => ({
        success: false,
        message: 'Reference number is required'
      }));
    }

    const apiUrl = `${localStorage.getItem('server_url')}b/system/v1/session/get_payment_details_debtor`;
    
     const data = {
      case_id: referenceNumber,
    };
    // The API expects the reference number as a query parameter
    return this.http.post(apiUrl, data).pipe(
      map(response => ({
        success: true,
        ...response
      })),
      catchError((error: HttpErrorResponse) => {
        console.error('Error fetching reference details:', error);
        return throwError(() => ({
          success: false,
          message: error.error?.message || 'An error occurred while fetching reference details',
          status: error.status
        }));
      })
    );
  }

  /**
   * Process payment by calling the payment_details_debtor_action API
   * @param paymentData Payment details including reference, amount, and card information
   * @returns Observable with the payment response
   */
  processPayment(paymentData: any): Observable<any> {
    const apiUrl = `${localStorage.getItem('server_url')}b/system/v1/session/payment_details_debtor_action`;
    
    // Transform data if needed to match your API requirements
    const requestPayload = {
      reference_number: paymentData.referenceNumber,
      amount: paymentData.amount,
      card_number: paymentData.cardDetails.number,
      expiry_date: paymentData.cardDetails.expiryDate,
      cvv: paymentData.cardDetails.cvv,
      // Add any additional fields required by your API
    };

    return this.http.post<PaymentResponse>(apiUrl, requestPayload).pipe(
      map(response => ({
        success: true,
        ...response
      })),
      catchError((error: HttpErrorResponse) => {
        console.error('Payment processing error:', error);
        return throwError(() => ({
          success: false,
          message: error.error?.message || 'An error occurred while processing your payment',
          status: error.status
        }));
      })
    );
  }

  /**
   * Get payment details for a specific case
   * @param caseId The ID of the case
   * @returns Observable with the payment details
   */
//   getPaymentDetails(caseId: string): Observable<any> {
//     const apiUrl = `${localStorage.getItem('server_url')}b/system/v3/payment_details_debtor_action?case_id=${caseId}`;
//     return this.http.get(apiUrl);
//   }

  // sendPaymentEmail(data: any): Observable<any>{
  //   const apiUrl = `${localStorage.getItem('server_url')}b/system/v1/session/send_payment_email`;
  //   return this.http.post(apiUrl, data).pipe(
  //     map(response => ({
  //       success: true,
  //       ...response
  //     })),
  //     catchError((error: HttpErrorResponse) => {
  //       console.error('Error sending payment email:', error);
  //       return throwError(() => ({
  //         success: false,
  //         message: error.error?.message || 'An error occurred while sending payment email',
  //         status: error.status
  //       }));
  //     })
  //   );
  // }
}
